import React from 'react';
import { Callout, FlexColumn, Text } from 'core/components';
import Markdown from 'app/components/markdown/Markdown';
import KaizenToolResult from '../KaizenToolResult';
import ReasoningBlock from './ReasoningBlock';
import ThinkingIndicator from './ThinkingIndicator';
import KaizenErrorMessage from './KaizenErrorMessage';
import { isStepInFlight } from '../util/turnStepGroups';

/** One step of a sub-agent run: its reasoning, its tool calls, and any error. */
const SubAgentTranscriptStep = ({ step, isRunActive, showFinalAnswer = true, sessionModel }) => {
  const { llm_response = {}, toolCalls } = step;
  const isProcessing = isRunActive && isStepInFlight(step);

  return (
    <FlexColumn gap="4px">
      <ReasoningBlock
        text={llm_response?.reasoning}
        label={step.isDelegationReasoning ? 'delegation reasoning' : 'reasoning'}
      />

      {showFinalAnswer && llm_response?.final_answer && step.processing_status === 'COMPLETED' && (
        <Markdown>{llm_response.final_answer}</Markdown>
      )}

      {toolCalls?.length > 0 && (
        <FlexColumn gap="6px">
          {toolCalls.map((toolCall) => (
            <KaizenToolResult
              key={toolCall.id || toolCall.tool_tracking_id}
              tool={toolCall}
              sessionModel={sessionModel}
              inline
            />
          ))}
        </FlexColumn>
      )}

      {step.error_message && step.error_message !== 'SCHEMA_FAILED' && (
        <Callout intent="danger">
          <Text small>
            Error: <KaizenErrorMessage message={step.error_message} fallback="something went wrong" />
          </Text>
        </Callout>
      )}

      {isProcessing && !toolCalls?.length && !llm_response?.reasoning && <ThinkingIndicator />}
    </FlexColumn>
  );
};

export default SubAgentTranscriptStep;
